import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";

import SkillsReducer from "./SkillsReducer";
import AcquisitionReducer from "./AcquisitionReducer";
import TrainersReducer from "./TrainersReducer";
import StatesReducer from "./StatesReducer"
import UsersReducer from "./UsersReducer";
import PartnersReducer from "./PartnersReducer";
import SkillSelectReducer from "./SkillSelectReducer";
import LoanStatusReducer from "./LoanStatusReducer";
import BuinessReducer from "./BusinessReducer";
import Loansreducer from "./LoansReducer";
import ActivityReducer from "./ActivityReducer";
import TrainingCentreRegReducer from "./TrainingCentreRegReducer";
import TregPhysicalApprovalReducer from "./TregPhysicalApprovalReducer";
import PostCampActivityReducer from "./PostCampActivityReducer";
import SuccessStoryReducer from "./SuccessStoryReducer";
import CmMgtReducer from "./CmMgtReducers";
import InCampActivityReducer from "./InCampActivityReducer";
import SystemSettingsReducer from "./SystemSettingsReducer"


// eslint-disable-next-line import/no-anonymous-default-export
export default () =>
  combineReducers({
    skillsReducer: SkillsReducer,
    acquisitionReducer: AcquisitionReducer,
    trainersReducer: TrainersReducer,
    toastr: toastrReducer,
    statesReducer: StatesReducer,
    usersReducer: UsersReducer,
    partnersReducer: PartnersReducer,
    skillSelectReducer: SkillSelectReducer,
    loanStatusReducer: LoanStatusReducer,
    loansReducer: Loansreducer,
    businessReducer: BuinessReducer,
    activityReducer: ActivityReducer,
    trainingCentreRegReducer: TrainingCentreRegReducer,
    tregPhysicalApprovalReducer: TregPhysicalApprovalReducer,
    postCampActivityReducer: PostCampActivityReducer,
    successStoryReducer: SuccessStoryReducer,
    cmMgtReducer: CmMgtReducer,
    inCampActivityReducer: InCampActivityReducer,
    systemSettings: SystemSettingsReducer,
  });


